(() => {
  const popup = document.querySelector("[data-saza-exit-offer]");
  if (!popup) return;

  const isProductPage = window.location.pathname.startsWith("/products/");
  const isCartOrCheckout =
    window.location.pathname.startsWith("/cart") ||
    window.location.pathname.startsWith("/checkouts");

  const storageKey = "sazaExitOfferSeenV3";
  const isTestMode = new URLSearchParams(window.location.search).has("saza_offer_test");
  const sevenDays = 7 * 24 * 60 * 60 * 1000;

  let opened = false;
  let addedToCart = false;
  let destinationUrl = null;

  if ((!isProductPage && !isTestMode) || isCartOrCheckout) return;

  const seenAt = Number(localStorage.getItem(storageKey));
  const seenRecently = seenAt && Date.now() - seenAt < sevenDays;

  if (seenRecently && !isTestMode) return;

  const continueLink = popup.querySelector(".saza-exit-offer__shop");

  const openOffer = (url = null) => {
    if (opened || addedToCart) return;

    opened = true;
    destinationUrl = url;
    popup.hidden = false;
    document.body.style.overflow = "hidden";

    if (continueLink) {
      if (destinationUrl) {
        continueLink.href = destinationUrl;
        continueLink.textContent = "Continue to your destination";
      } else {
        continueLink.href = "/collections/all";
        continueLink.textContent = "Continue shopping";
      }
    }
  };

  const closeOffer = () => {
    popup.hidden = true;
    document.body.style.overflow = "";
    localStorage.setItem(storageKey, String(Date.now()));
  };

  document.addEventListener("submit", (event) => {
    if (event.target.matches('form[action*="/cart/add"]')) {
      addedToCart = true;
    }
  });

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]");

    if (
      !link ||
      opened ||
      addedToCart ||
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === "_blank" ||
      link.hasAttribute("download")
    ) return;

    const url = new URL(link.href, window.location.origin);
    const isInternalLink = url.origin === window.location.origin;
    const isCurrentPage = url.pathname === window.location.pathname;
    const isHashLink = url.hash && url.pathname === window.location.pathname;

    if (!isInternalLink || isCurrentPage || isHashLink) return;

    event.preventDefault();
    openOffer(url.href);
  });

  popup.querySelectorAll("[data-saza-offer-close]").forEach((element) => {
    element.addEventListener("click", closeOffer);
  });

  popup.querySelector("[data-saza-copy-code]")?.addEventListener("click", async (event) => {
    const button = event.currentTarget;

    try {
      await navigator.clipboard.writeText("SAZA2026");
      button.textContent = "Copied";
    } catch {
      button.textContent = "SAZA2026";
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !popup.hidden) closeOffer();
  });

  if (isTestMode) {
    setTimeout(openOffer, 900);
    return;
  }

  setTimeout(() => {
    openOffer();
  }, 15000);
})();